/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/


import React, { Component } from 'react';
import ListingPage from './ListingPage';
import { linkFormatter } from '../util/LinkFormatter';
import PropTypes from 'prop-types';


/**
 * Vmtas page of web monitor.
 */
export default class Vmtas extends Component {
    static propTypes = {
        showError: PropTypes.func.isRequired,
        setRefresh: PropTypes.func.isRequired,
        setRefreshInterval: PropTypes.func.isRequired
    };


    formatPercent(value) {
        return value !== undefined ? value + '%' : value
    }


    render() {
        let columns = {
            'Name': 'name',
            'Domains': 'dom',
            '#Rcpt': 'rcp',
            '%Total': 'pctOfTotal',
            '#KBytes': 'kb',
            '#Conn': 'conn'
        }

        let columnFormatter = {
            Name: linkFormatter.linkVmta,
            '%Total': this.formatPercent
        }

        return (
            <ListingPage name='vmta'
                         defaultName='*'
                         urlPath='/vmtas'
                         items='vmtas'
                         columns={columns}
                         showError={this.props.showError}
                         columnFormatter={columnFormatter}
                         setRefresh={this.props.setRefresh}
                         setRefreshInterval={this.props.setRefreshInterval}/>
        );
    }
}
